"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientCookieManager = exports.splitToken = exports.getCookieValue = exports.cookieCategoryListToMap = exports.canSetCookie = void 0;
var canSetCookie_1 = require("./helpers/canSetCookie");
Object.defineProperty(exports, "canSetCookie", { enumerable: true, get: function () { return canSetCookie_1.canSetCookie; } });
var cookieCategoryListToMap_1 = require("./helpers/cookieCategoryListToMap");
Object.defineProperty(exports, "cookieCategoryListToMap", { enumerable: true, get: function () { return cookieCategoryListToMap_1.cookieCategoryListToMap; } });
var getCookieValue_1 = require("./helpers/getCookieValue");
Object.defineProperty(exports, "getCookieValue", { enumerable: true, get: function () { return getCookieValue_1.getCookieValue; } });
var splitToken_1 = require("./helpers/splitToken");
Object.defineProperty(exports, "splitToken", { enumerable: true, get: function () { return splitToken_1.splitToken; } });
let ClientCookieManager;
if (typeof window !== 'undefined') {
    // Dynamically import the client-specific implementation
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    exports.ClientCookieManager = ClientCookieManager = require('./helpers/ClientCookieManager').ClientCookieManager;
}
//# sourceMappingURL=index.js.map